import Http from 'src/helpers/httpClient';

export default {
  fetchPlaylistData(url: string) {
    return Http.get(url, { isPublic: true });
  },
};
